module.exports = __webpack_public_path__ + "static/bardier&adams-0bc0a756dbf3694434505ba713f56d5c.jpg";